import styled from 'styled-components';

export const LayoutStyles = styled.div`
  margin: 0 auto;
  max-width: 60.75em;

  @media (max-width: 970px) {
    margin: 0 1em;
  }
`;
